import React from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';

const WidgetOptionsForm = ({ initialValues, handleChange, children, ...formProps }) => {
	return (
		<Form
			initialValues={initialValues}
			onChange={handleChange}
			onFinish={handleChange}
			autoSave
			{...formProps}
		>
			<div className="WidgetUpdateForm">{children}</div>
		</Form>
	);
};

export default WidgetOptionsForm;
